import React from 'react'
import Image from 'next/image'
import Link from 'next/link';
import blogimg1 from "../../public/images/blogimg1.png";
import blogimg2 from "../../public/images/blogimg2.jpg";
import blogimg3 from "../../public/images/blogimg3.jpg";
import blogimg4 from "../../public/images/blogimg4.png";

const Blogscatogries = () => {
  return (
   <>
                            <div className="columns">
                            <span className="title mb-5"> <h2 className='text-[#fff] text-3xl'>Categories</h2></span>
                                <ul className="widget-category-list">
                                    <li className="img-hover-move">
                                        <Link href="#" className="media"><Image src={blogimg1} alt='entry level hiring'/>Student <span>90</span></Link>
                                    </li>
                                    <li className="img-hover-move">
                                        <Link href="#" className="media"><Image src={blogimg2} alt='fresher hire'/>Campus <span>15</span></Link>
                                    </li>
                                    <li className="img-hover-move">
                                        <Link href="#" className="media"><Image src={blogimg3} alt='placement portal'/>Corporate <span>85</span></Link>
                                    </li>
                                    <li className="img-hover-move">
                                        <Link href="#" className="media"><Image src={blogimg4} alt='online placement'/>Placements<span>24</span></Link>
                                    </li>
                                </ul>
                            </div>
   </>
  )
}

export default Blogscatogries